import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { BASE_URL } from '../services/ApiService/ApiConfig';
import { tokenActual } from './sesionCliente';
import ActivarSegundoFactor from './ActivarSegundoFactor';

const fecha = (v) => (v ? new Date(v).toLocaleString('es-EC') : '');
const navegador = (ua) => {
    if (!ua) return 'Desconocido';
    if (ua.includes('Edg/')) return 'Edge';
    if (ua.includes('Chrome/')) return 'Chrome';
    if (ua.includes('Firefox/')) return 'Firefox';
    if (ua.includes('Safari/')) return 'Safari';
    if (ua.includes('Dart')) return 'App movil';
    return ua.substring(0, 30);
};

/** Boton del topbar: segundo factor propio y sesiones abiertas del usuario (ADR-002 S4). */
const MiSeguridad = () => {
    const [visible, setVisible] = useState(false);
    const [estado, setEstado] = useState(null);
    const [activando, setActivando] = useState(false);
    const [error, setError] = useState('');

    const auth = () => ({ 'Content-Type': 'application/json', Authorization: `Bearer ${tokenActual()}` });

    const cargar = async () => {
        setError('');
        try {
            const res = await fetch(`${BASE_URL}/seguridad/mi`, { headers: auth() });
            if (!res.ok) throw new Error('No se pudo leer su seguridad');
            setEstado(await res.json());
        } catch (e) {
            setError(e.message);
        }
    };

    const abrir = () => {
        setVisible(true);
        setActivando(false);
        cargar();
    };

    const cerrarOtra = async (sesionId) => {
        await fetch(`${BASE_URL}/seguridad/mi/sesiones/cerrar`, { method: 'POST', headers: auth(), body: JSON.stringify({ sesionId }) });
        cargar();
    };

    return (
        <>
            <button className="mr-3 layout-topbar-action rounded-circle p-link" onClick={abrir} title="Mi seguridad" aria-label="Mi seguridad">
                <i className="pi pi-shield fs-large"></i>
            </button>
            <Dialog header="Mi seguridad" visible={visible} style={{ width: 'min(36rem, 95vw)' }} onHide={() => setVisible(false)}>
                {error && <p className="text-red-600">{error}</p>}
                {estado && !activando && (
                    <div className="flex flex-column gap-4">
                        <section>
                            <h5 className="mb-2">Segundo factor</h5>
                            {estado.segundoFactorActivo ? (
                                <Tag severity="success" value="Activo" icon="pi pi-check" />
                            ) : (
                                <div className="flex flex-column gap-2">
                                    <Tag severity="warning" value="No activado" />
                                    {estado.puedeActivar ? (
                                        <Button label="Activar segundo factor" icon="pi pi-mobile" className="align-self-start" onClick={() => setActivando(true)} />
                                    ) : (
                                        <small className="text-600">El segundo factor aun no esta habilitado en el servidor.</small>
                                    )}
                                </div>
                            )}
                            {estado.politicaSegundoFactor === 'OBLIGATORIO' && <p className="mt-2 mb-0 text-600">Su rol lo exige.</p>}
                        </section>
                        <section>
                            <h5 className="mb-2">Sesiones abiertas</h5>
                            {(estado.sesiones || []).length === 0 && <small className="text-600">Sin sesiones registradas.</small>}
                            {(estado.sesiones || []).map((s) => (
                                <div key={s.sesion_id} className="flex align-items-center justify-content-between py-2 border-bottom-1 surface-border">
                                    <div>
                                        <div><b>{navegador(s.user_agent)}</b> · {s.ip}</div>
                                        <small className="text-600">Desde {fecha(s.fecha_inicio)} · ultimo uso {fecha(s.fecha_ultimo_uso)}</small>
                                    </div>
                                    <Button icon="pi pi-times" className="p-button-text p-button-danger" title="Cerrar esa sesion"
                                        aria-label="Cerrar esa sesion" onClick={() => cerrarOtra(s.sesion_id)} />
                                </div>
                            ))}
                        </section>
                    </div>
                )}
                {activando && <ActivarSegundoFactor alTerminar={() => { setActivando(false); cargar(); }} />}
            </Dialog>
        </>
    );
};

export default MiSeguridad;
